/**
 * The en resource bundle, in one module so the bundler emits one chunk for it.
 *
 * Spec 23.2: "locale bundles split so a German user never downloads Russian strings."
 * That splitting is what this file is for — `lib/i18n.ts` imports `en` statically (it is
 * the fallback and the first paint) and the other three through `import()`, and a barrel
 * per locale is what makes each of those a single request instead of seven.
 */
import admin from '../../../locales/en/admin.json';
import ai from '../../../locales/en/ai.json';
import billing from '../../../locales/en/billing.json';
import board from '../../../locales/en/board.json';
import common from '../../../locales/en/common.json';
import errors from '../../../locales/en/errors.json';
import landing from '../../../locales/en/landing.json';
import pages from '../../../locales/en/pages.json';
import profile from '../../../locales/en/profile.json';
import sessions from '../../../locales/en/sessions.json';
import studio from '../../../locales/en/studio.json';

/* Named, not default: CLAUDE.md reserves default exports for React route components. */
export const resources = {
  common,
  board,
  studio,
  errors,
  ai,
  billing,
  admin,
  landing,
  pages,
  profile,
  sessions,
};
